import type { ITokenStore } from "@infra/interfaces/storage/ITokenStore";

const ID_TOKEN_KEY = "rogo_id_token";
const JWT_KEY = "jwt";
const REFRESH_TOKEN_KEY = "refreshToken";

/**
 * Browser-backed `ITokenStore` adapter that persists tokens in `localStorage`.
 * Storage key names are kept identical to the legacy direct-`localStorage` calls
 * (`rogo_id_token`, `jwt`, `refreshToken`) so existing sessions continue to work.
 */
export const browserTokenStore: ITokenStore = {
	getIdToken: () => localStorage.getItem(ID_TOKEN_KEY),
	setIdToken: (token) => localStorage.setItem(ID_TOKEN_KEY, token),

	getJwt: () => localStorage.getItem(JWT_KEY),
	setJwt: (token) => localStorage.setItem(JWT_KEY, token),

	getRefreshToken: () => localStorage.getItem(REFRESH_TOKEN_KEY),
	setRefreshToken: (token) => localStorage.setItem(REFRESH_TOKEN_KEY, token),

	clearAll: () => {
		localStorage.removeItem(ID_TOKEN_KEY);
		localStorage.removeItem(JWT_KEY);
		localStorage.removeItem(REFRESH_TOKEN_KEY);
	},
};
